module.exports = __webpack_public_path__ + "img/not-started.4014bc5a.svg";